import { gql } from 'graphql-tag'

import MoneyContent from '@Queries/cms/fragments/MoneyContent.fragment'

export default gql`
  ${MoneyContent}
  fragment PriceFragment on Price {
    ...MoneyContent
    discount {
      percent
      code {
        context
      }
      ...MoneyContent
    }
  }
`
